import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section id="hero" className="relative flex min-h-screen items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20african%20city%20market%20digital%20commerce%20technology%20modern%20africa%20aerial%20view%20golden%20hour%20warmth%20energy%20people%20thriving%20economy%20wide%20panoramic%20scene&width=1600&height=900&seq=fsn-hero-01&orientation=landscape"
        alt="Foi Senegal Platform"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/75 to-navy/50"></div>

      <div className="pointer-events-none absolute right-20 top-32 h-64 w-64 rounded-full bg-gold/10 blur-3xl"></div>
      <div className="pointer-events-none absolute bottom-24 left-10 h-48 w-48 rounded-full bg-white/5 blur-2xl"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 py-32">
        <div className="max-w-3xl">
          <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/20 px-4 py-2">
            <span className="h-2 w-2 animate-pulse rounded-full bg-gold"></span>
            <span className="text-sm font-semibold text-gold">Foi Sénégal – Vivre sa foi au Sénégal</span>
          </div>

          <h1 className="mb-6 text-5xl font-bold leading-tight text-white md:text-6xl xl:text-7xl">
          Églises - Événements
            <br />
            <span className="text-gold"> Communauté - Boutique</span>
          </h1>
          <p className="mb-10 max-w-2xl text-lg leading-relaxed text-white/75 md:text-xl">
             Foi Sénégal est la plateforme digitale dédiée à la vie chrétienne au Sénégal.
             L’application rassemble en un seul endroit les églises, les événements chrétiens, les informations essentielles et une boutique chrétienne, pour permettre à chacun de vivre pleinement sa foi au quotidien.
          </p>

          <div className="mb-16 flex flex-col gap-4 sm:flex-row">
            <button
              onClick={() => navigate('/register')}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-gold px-8 py-4 text-base font-bold text-white transition-all hover:bg-gold-dark"
            >
              <i className="ri-rocket-line text-lg"></i>
              Commencer gratuitement
            </button>
            <button
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-white/30 bg-white/15 px-8 py-4 text-base font-semibold text-white transition-all hover:bg-white/25"
            >
              <i className="ri-play-circle-line text-lg"></i>
              Decouvrir la plateforme
            </button>
          </div>

          <div className="flex flex-wrap gap-8">
            {[
              { value: '5', label: 'Vendeurs actifs', icon: 'ri-store-2-line' },
              { value: '2', label: 'Événements organisés', icon: 'ri-calendar-event-line' },
              { value: '8', label: 'Transactions réalisées', icon: 'ri-exchange-line' },
              { value: 'Dakar +', label: 'Quelques régions', icon: 'ri-map-pin-line' },
            ].map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10">
                  <i className={`${stat.icon} text-lg text-gold`}></i>
                </div>
                <div>
                  <p className="text-xl font-bold leading-none text-white">{stat.value}</p>
                  <p className="mt-0.5 text-xs text-white/55">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 flex -translate-x-1/2 animate-bounce flex-col items-center gap-2">
        <p className="text-xs text-white/50">Decouvrir</p>
        <i className="ri-arrow-down-line text-lg text-white/50"></i>
      </div>
    </section>
  );
}
